module.exports = __webpack_public_path__ + "static/media/applications.1a2ab5e2.jpg";